<template>
  <layout
    username="Agent"
    current-page="Drafted Sales"
    link-to-edit="/agent-dashboard/edit-profile"
  >
    <template slot="menuItems">
      <li v-for="{ title, icon, path } in menu" :key="title" class="nav-item">
        <MenuItems :menu-item="title" :icon-menu="icon" :to-where="path" />
      </li>
    </template>
    <template slot="content">
      <div class="jumbotron">
        <div class="my-3">Total: {{ drafts.count }}</div>
        <div class="row justify-content-between mb-3">
          <div class="col-4">
            <a-input-search
              v-model="searchQuery"
              placeholder="Search ..."
              @search="onSearch"
            />
          </div>
        </div>
        <sales-table :data="drafts.data" :draft="true" :loading="loading" />
        <pagination
          :pages="drafts.pages"
          :on-paginate="onPaginate"
          :current-page="currentPage"
        />
      </div>
    </template>
  </layout>
</template>

<script>
import { mapGetters } from "vuex";
import Layout from "../../components/Layout";
import MenuItems from "../../components/MenuItems";
import SalesTable from "../../components/Tables/SalesTable.vue";
import Pagination from "../../components/Pagination.vue";
export default {
  name: "Recordsale",
  components: {
    Layout,
    MenuItems,
    SalesTable,
    Pagination,
  },
  data() {
    return {
      menu: [
        {
          title: "Record Sale",
          icon: "fa fa-cash-register",
          path: "/agent",
        },
        {
          title: "Drafted Records",
          icon: "fa fa-edit",
          path: "/agent/drafts",
        },
        {
          title: "View Sales",
          icon: "fa fa-table",
          path: "/agent/sales",
        },
      ],
      currentPage: 1,
      searchQuery: "",
      timer: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({ drafts: "sales/agentDrafts" }),
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData(search) {
      this.loading = true;
      try {
        this.$store.dispatch("sales/getDrafts", {
          search,
        });
      } catch (error) {
        this.$message.error(error.message || error);
      } finally {
        this.loading = false;
      }
    },
    onSearch() {
      this.fetchData(this.searchQuery);
    },
    onPaginate(value) {
      if (value > 0 && value < this.drafts.pages + 1) {
        this.currentPage = value;
        this.$store.dispatch("sales/getDrafts", {
          search: this.searchQuery,
          page: this.currentPage,
        });
      }
    },
  },
};
</script>

<style scoped>
.nav-item {
  cursor: pointer;
}

.nav-item .nav-link:hover {
  color: #8bc34a;
}
.jumbotron {
  overflow-x: scroll;
}
</style>
